// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagsOutlinedSvg from "@fishx/icons-svg/es/asn/TagsOutlined";
import FishxIcon from '../components/FishxIcon';

var TagsOutlined = function TagsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagsOutlinedSvg
  }));
};

TagsOutlined.displayName = 'TagsOutlined';
export default React.forwardRef(TagsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagsOutlined.js
// module id = 4244
// module chunks = 0